export const modaisConta = {
  editarContaBancaria: 'editarContaBancaria',
  editarContaCaixinha: 'editarContaCaixinha',
  editarContaCartao: 'editarContaCartao',
  visualizarContaBancaria: 'visualizarContaBancaria',
  visualizarContaCaixinha: 'visualizarContaCaixinha',
  visualizarContaCartao: 'visualizarContaCartao',
};
